// ClipRadar — the problem interstitial: a dark wall of filenames (the library you
// can't see into) with the two-line truth over it. Sits between the hero and the
// first showcase; the sections after it are the answer. Reveal choreography is
// CSS-only, keyed off the section-level .crw-in class (fnw-* rules in site.css).

// Real-shaped names, written for us (media extensions only — this is footage).
const ROWS: string[][] = [
  ['MASTERS_do_not_delete.mov', 'vacation_raw_2023.mp4', 'IMG_4821.MOV', 'timeline_export_01.mov', 'sequence_a_b_FINAL.mp4', 'DJI_0042.mp4', 'b_roll.mp4'],
  ['color_graded_v2.mov', 'talking_head_crop.MOV', 'render_h265_test.mp4', 'wide_st_market_60fps.mp4', 'church_interior_4k.mp4', 'cut_60s_v4.mp4', 'GX000189.mp4'],
  ['interview_raw_003.mxf', 'clip_FINAL_v3.mov', 'DSCN_0042.mp4', 'b_roll_street_2.mp4', 'podium_speech_cam2.mxf', 'IMG_5284_edited.mp4', 'drone_pass_07.mp4'],
  ['project_backup_2024.mp4', 'raw_capture_001.mov', 'new_edit_FINAL_FINAL.mp4', 'client_NDA_cut.mov', 'bts_footage_day2.mp4', 'masters_compressed.mp4', 'untitled_project_copy.mp4'],
  ['rooftop_bts_01.mov', 'test_sequence_03.MOV', 'audio_synced_take4.mov', 'ep41_selects_OLD.mov', 'wedding_prep_cam1.mp4', 'rough_cut_v7.mov', 'archive_2019_dump.mp4'],
  ['golden_hour_attempt2.mp4', 'interview_B_cam1.mxf', 'GOPR0221.MP4', 'stage_wide_LOCKED.mov', 'pickup_shots_friday.mp4', 'export_for_review_v12.mp4', 'sunrise_timelapse_8.mov'],
];

// per-row horizontal jitter so the wall reads organic, not tabular
const OFFSETS = [-40, 60, -110, 20, -70, 90];

export function FilenameWall() {
  return (
    <section id="everything" style={{ position: 'relative', padding: '40px 0', overflow: 'hidden' }}>
      <div style={{ position: 'relative', minHeight: 440, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {/* the wall */}
        <div aria-hidden="true" style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '30px 0', maskImage: 'radial-gradient(ellipse 82% 90% at 50% 50%, black 30%, transparent 90%)', WebkitMaskImage: 'radial-gradient(ellipse 82% 90% at 50% 50%, black 30%, transparent 90%)' }}>
          {ROWS.map((row, i) => (
            <div key={i} style={{ display: 'flex', gap: 44, justifyContent: 'center', whiteSpace: 'nowrap', marginLeft: OFFSETS[i] }}>
              {row.map((f, j) => (
                <span key={f} style={{ fontFamily: 'var(--font-mono)', fontSize: 11.5, letterSpacing: '0.02em', color: 'var(--fg-4)', opacity: (i + j) % 3 === 0 ? 0.7 : 0.45, flex: 'none' }}>{f}</span>
              ))}
            </div>
          ))}
        </div>
        {/* legibility veil behind the words */}
        <div aria-hidden="true" style={{ position: 'absolute', inset: 0, background: 'radial-gradient(ellipse 52% 62% at 50% 50%, rgba(5,5,6,0.92), rgba(5,5,6,0.45) 60%, transparent 80%)' }}></div>

        {/* the radar touches the chaos — three one-shot pings sweep the wall as
            "that's what the radar is for" lands (CSS-only, keyed off .crw-in) */}
        <div aria-hidden="true" style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}>
          <span className="fnw-ping" style={{ left: '21%', top: '20%' }}><i></i><b></b></span>
          <span className="fnw-ping" style={{ left: '76%', top: '40%' }}><i></i><b></b></span>
          <span className="fnw-ping" style={{ left: '35%', top: '76%' }}><i></i><b></b></span>
        </div>

        {/* the truth */}
        <div style={{ position: 'relative', textAlign: 'center', padding: '0 24px' }}>
          <h2 className="fnw-l1" style={{ margin: 0, fontFamily: 'var(--font-display)', fontSize: 'clamp(38px, 5vw, 64px)', fontWeight: 600, letterSpacing: 'var(--tracking-display)', lineHeight: 1.06, color: 'var(--fg-1)' }}>
            You filmed everything.
          </h2>
          <p className="fnw-l2" style={{ margin: '10px 0 0', fontFamily: 'var(--font-display)', fontSize: 'clamp(38px, 5vw, 64px)', fontWeight: 600, letterSpacing: 'var(--tracking-display)', lineHeight: 1.06, color: 'rgba(244,245,247,0.26)' }}>
            You can't find any of it.
          </p>
          <p className="fnw-l3" style={{ margin: '30px 0 0', fontFamily: 'var(--font-mono)', fontSize: 11.5, letterSpacing: '0.16em', textTransform: 'uppercase', color: 'var(--signal-300)' }}>
            That's what the radar is for
          </p>
        </div>
      </div>
    </section>
  );
}
